import { Link, useParams } from 'react-router-dom';
import { faChevronRight, faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ef } from './effectUtils';

export function parseMarginPadding(mp){
    const mt = (mp.Margin.Top != "")? parseInt(mp.Margin.Top): 0;
    const mr = (mp.Margin.Right != "")? parseInt(mp.Margin.Right): 0;
    const mb = (mp.Margin.Bottom != "")? parseInt(mp.Margin.Bottom): 0;
    const ml = (mp.Margin.Left != "")? parseInt(mp.Margin.Left): 0;
    const pt = (mp.Padding.Top != "")? parseInt(mp.Padding.Top): 0;
    const pr = (mp.Padding.Right != "")? parseInt(mp.Padding.Right): 0;
    const pb = (mp.Padding.Bottom != "")? parseInt(mp.Padding.Bottom): 0;
    const pl = (mp.Padding.Left != "")? parseInt(mp.Padding.Left): 0;

    return {
        marginTop: mt,
        marginRight: mr,
        marginBottom: mb,
        marginLeft: ml,
        paddingTop: pt,
        paddingRight: pr,
        paddingBottom: pb,
        paddingLeft: pl
    }
}

export function continueBtn(action, size){
    const styles = {
        lgBtn:{
            background: '#fff',
            color: '#666',
            width: 140,
            padding: '5px 15px',
            fontSize: 14,
            fontWeight: 600,
            borderRadius: 30,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        },
        smBtn:{
            background: '#fff',
            color: '#666',
            padding: '5px 15px',
            fontSize: 14,
            fontWeight: 600,
            borderRadius: 30,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        },
        btnIcon:{
            fontSize:18
        },
    }

    const lg = (
        <Link onClick={()=>action()} style={styles.lgBtn} className='btn'>
            <span>CONTINUE &nbsp;&nbsp;</span>
            <FontAwesomeIcon icon={faChevronCircleRight} style={styles.btnIcon} />
        </Link>
    )

    const sm = (
        <Link onClick={()=>action()} style={styles.smBtn} className='btn'>
            <span>CONTINUE &nbsp;&nbsp;</span>
            <FontAwesomeIcon icon={faChevronRight} style={styles.btnIcon} />
        </Link>
    )

    return (
        <div>
            {(size == "lg") && lg}
            {(size == "sm") && sm}
        </div>
    )
}

export function parseResult(elem, obj, entry){

    //check if presentation
    if(entry == "presentation"){

        const setup = obj.Presentation; 
        let animatn = "zoom"; 
        let duratn = 0.5; 

        //check if presentation is edited
        if(setup != ""){
            const ptn = JSON.parse(setup);
            animatn = ptn.Animation;
            duratn = parseFloat(ptn.Duration);
        }
        
        return ef(elem, animatn, duratn);
    }

    return elem;
}

export function parseItemResult(elem, obj, entry, plus){

    //check if presentation
    if(entry == "presentation"){

        const setup = obj.Presentation; 
        let animatn = "zoom"; 
        let duratn = 0.5; 

        //check if presentation is edited
        if(setup != ""){
            const ptn = JSON.parse(setup);
            animatn = ptn.Animation;
            duratn = parseFloat(ptn.Duration);
        }
        
        return ef(elem, animatn, duratn + plus);
    }

    return elem;
}